import { Card, CardContent } from "@/components/ui/card";
import { Award, Users, Clock, ShieldCheck } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Expertise depuis 2015",
    description: "Plus de 10 ans d'expérience dans le nettoyage professionnel à Nantes et sa région"
  },
  {
    icon: Users,
    title: "Équipe qualifiée",
    description: "Personnel formé et équipé de matériel professionnel de dernière génération"
  },
  {
    icon: Clock,
    title: "Disponibilité",
    description: "Services adaptés à vos horaires, interventions rapides et ponctuelles"
  },
  {
    icon: ShieldCheck,
    title: "Garantie qualité",
    description: "Satisfaction garantie avec des prestations conformes aux normes en vigueur"
  }
];

const WhyChooseUs = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Pourquoi choisir{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              EPP ?
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Votre partenaire de confiance pour des prestations de nettoyage professionnelles et personnalisées
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="border-2 hover:border-primary transition-all duration-300 animate-fade-up group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="pt-6">
                <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 group-hover:bg-gradient-primary transition-all">
                  <feature.icon className="h-6 w-6 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
